/* ⚠️ `cart:refresh`, PAS `onix:cart-rendered` — ÉVÉNEMENT VÉRIFIÉ le 24/08.
   J'écoutais `onix:cart-rendered` : **il n'est émis nulle part**. Le tiroir ne
   dispatche que `cart:refresh` (5 fois dans cart-drawer.js). Cette prévision de
   livraison ne se remettait donc JAMAIS à jour après un changement de panier —
   sans erreur, sans trace : un écouteur sur un événement jamais émis ne fait
   rien, silencieusement.
   Trouvé par `scripts/verifier-references.js`, pas par un test : aucun test ne
   voit un écouteur muet. */
/**
 * PRÉVISION DE LIVRAISON — le même calcul partout où le bloc apparaît.
 *
 * ⚠️ EXTRAIT DE product.liquid LE 23/08, quand il a demandé la même prévision
 *   dans le tiroir de panier. Le dupliquer aurait garanti qu'un jour les deux
 *   divergent : on corrige l'un, on oublie l'autre, et la fiche annonce une
 *   date que le panier contredit — sur la page où l'on décide de payer.
 *
 * ⚠️ JOURS OUVRÉS : le dimanche NE COMPTE PAS. Ce n'est pas « éviter le
 *   dimanche » : sur 21 jours il y en a trois, donc trois jours d'écart entre
 *   les deux méthodes.
 *
 * ⚠️ RECALCULÉ À CHAQUE APPEL, jamais rendu en dur : une date figée devient
 *   fausse dès que la page reste ouverte, qu'elle est mise en cache, ou que le
 *   client revient le lendemain. C'est aussi pourquoi le tiroir le rappelle à
 *   chaque ouverture.
 */
(function () {
  function dans(n) {
    var d = new Date(), restants = n;
    while (restants > 0) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) restants--;   /* 0 = dimanche, il ne compte pas */
    }
    return d;
  }

  function ecrire(d, langue) {
    try { return new Intl.DateTimeFormat(langue, { day: 'numeric', month: 'short' }).format(d); }
    catch (e) { return d.getDate() + '/' + (d.getMonth() + 1); }
  }

  function peindre(bloc) {
    if (!bloc) return;
    var langue = (document.documentElement.lang || 'fr').slice(0, 2);
    var min = parseInt(bloc.dataset.min, 10) || 7;
    var moy = parseInt(bloc.dataset.moy, 10) || 14;
    var max = parseInt(bloc.dataset.max, 10) || 21;
    bloc.querySelectorAll('[data-livr-date]').forEach(function (el) {
      var n = el.dataset.livrDate === 'min' ? min : (el.dataset.livrDate === 'max' ? max : moy);
      el.textContent = ecrire(dans(n), langue);
    });
    /* Le point suit la moyenne DANS la fourchette : si les délais changent en
       réglage, il se replace tout seul au lieu de rester figé au milieu. */
    var pt = bloc.querySelector('[data-livr-point]');
    if (pt && max > min) {
      pt.style.left = Math.min(96, Math.max(4, ((moy - min) / (max - min)) * 100)) + '%';
    }
  }

  function tout() { document.querySelectorAll('[data-livraison]').forEach(peindre); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout);
  else tout();

  /* Le tiroir de panier se re-rend en JS à chaque changement : sans ce rappel,
     ses dates disparaîtraient au premier ajout d'article. */
  window.onixLivraison = tout;
  document.addEventListener('cart:refresh', tout);

  /* ⛔ ET LA FICHE SE RE-REND AUSSI — 30/08, 03h10. C'EST LUI QUI L'A VU.
       « pour les délais de livraison des fois il ne s'affiche plus ».

     CE QUI SE PASSAIT : un changement de coloris remplace toute la section
     produit par du HTML neuf. Le Liquid rend les `[data-livr-date]` VIDES —
     c'est ce script qui les remplit. Or il n'écoutait que `DOMContentLoaded`
     (passé depuis longtemps) et `cart:refresh` (le panier, pas la fiche).
     Personne ne le rappelait : les dates restaient vides pour toujours.

     PROVOQUÉ EN LABORATOIRE, pas déduit :
       au chargement      6 dates remplies, 0 vide
       après 1 coloris    3 vides — les 3 de la fiche
       après 2 coloris    3 vides — ça ne se répare jamais tout seul
     Les 3 dates du tiroir restaient bonnes : le tiroir n'est pas dans la
     section remplacée. C'est ce qui rendait le défaut intermittent à l'œil.

     ⚠️ C'EST LA MÊME FAMILLE QUE LES SIX AUTRES COMPOSANTS DE CETTE PAGE, et la
       section tenait DEUX listes de rejeu tenues à la main qui divergeaient déjà
       (`__onixQuantite` n'était que dans l'une des deux). Une liste centrale
       oublie toujours un composant un jour.
       ➜ On ne s'ajoute donc PAS à une liste : le composant écoute lui-même.
         Il devient autonome, et un futur bloc livraison marchera sans que
         personne n'ait à penser à l'inscrire quelque part.

     A/B mesuré avant de choisir (4 variantes, même page, même geste) :
       témoin sans correction ......... 3 vides  ⛔
       rejouer la livraison à l'échange  0 vide  ✅  ← retenu
       rejouer tout `window.onix*` ..... 0 vide  ✅  (balaie window : écarté)
       leurre sur un événement absent .. 3 vides  ⛔  (prouve que le test mord)
     Contrôle : node scripts/verifier-livraison-affichee.js */
  document.addEventListener('onix:product:swapped', tout);

  /* ═══ LE PANNEAU « DÉTAILS » — 30/08 ═════════════════════════════════════
     Sa demande : « fais en sorte qu'il y ait un texte cliquable pour donner plus
     de détails sur la livraison et rassurer le client ».

     ⛔ TOUT PASSE PAR UNE DÉLÉGATION SUR `document`. Le panneau vit DANS la
       section produit, donc il est remplacé à chaque changement de coloris :
       un écouteur posé sur le bouton serait mort au premier clic sur une
       pastille. C'est le piège qui a cassé six composants de cette page le
       29/08, puis les dates de livraison elles-mêmes le 30/08. On ne capture
       aucun nœud — on interroge le DOM au moment du clic.

     ⚠️ LES TARIFS NE SONT PAS ÉCRITS ICI. Ils viennent de
       `assets/frais-livraison.json`, généré depuis Shopify par
       `scripts/frais-livraison.js`. Un prix recopié à la main serait faux au
       premier changement de zone — et un prix faux s'affiche exactement comme
       un prix juste. */
  /* ⛔ LE PANNEAU DOIT SORTIR DE LA SECTION — 30/08, 06h00. C'EST LUI QUI L'A VU :
       « quand on clique sur la livraison c'est une pop up bas de page qui est
       censé s'ouvrir, là actuellement t'a fais de la merde ».

     CE QUI SE PASSAIT, MESURÉ : la carte se posait à 1202 px du haut sur un
     écran de 844. Elle était donc ENTIÈREMENT hors champ, en dessous — il
     fallait faire défiler la page pour tomber dessus.

     LA CAUSE : `position: fixed` s'ancre sur l'écran… SAUF si un ancêtre porte
     un `transform`, un `filter`, une `perspective` ou un `will-change`. Dans ce
     cas l'élément s'ancre sur CET ancêtre. Ici c'est `.onix-product__actions`,
     qui garde un `transform: matrix(1,0,0,1,0,0)` — l'identité, résidu de son
     animation d'arrivée en `forwards`. Une transformation qui ne transforme
     rien, et qui casse quand même tous les `fixed` de ses descendants.

     ⚠️ ET MA CAPTURE NE L'A PAS MONTRÉ. J'ai photographié le panneau après un
       `scrollIntoView` — donc au seul endroit de la page où le défaut ne se
       voyait pas — et je lui ai envoyé l'image comme preuve que ça marchait.
       Une capture prise à l'endroit qui arrange ne prouve rien.

     ➜ ON DÉPLACE LE PANNEAU DANS <body>. C'est la seule correction qui ne
       dépende d'aucun ancêtre : retirer le transform de `.onix-product__actions`
       aurait marché aujourd'hui et cassé au prochain ancêtre animé.
     ⚠️ Il est déplacé À CHAQUE ÉCHANGE DE SECTION, et l'ancien est retiré avant :
       le panneau porte les délais du produit courant, rendus par Liquid. Garder
       le premier afficherait les dates d'un autre coloris. */
  function sortirDuFlux() {
    var dansLaSection = document.querySelector('.onix-product [data-livr-panneau]');
    var dejaSorti = document.querySelector('body > [data-livr-panneau]');
    if (!dansLaSection) return;                 /* déjà déplacé, rien à faire */
    if (dejaSorti) dejaSorti.remove();          /* jamais deux panneaux */
    document.body.appendChild(dansLaSection);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sortirDuFlux);
  else sortirDuFlux();
  document.addEventListener('onix:product:swapped', sortirDuFlux);

  var tarifs = null;
  var chargement = null;

  function urlTarifs() {
    /* l'URL de l'asset est déposée par le Liquid sur le panneau lui-même :
       un chemin en dur casserait au moindre changement de CDN. */
    var p = document.querySelector('[data-livr-panneau]');
    return (p && p.dataset.tarifs) || '';
  }

  function chargerTarifs() {
    if (tarifs) return Promise.resolve(tarifs);
    if (chargement) return chargement;
    var u = urlTarifs();
    if (!u) return Promise.resolve(null);
    chargement = fetch(u)
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { tarifs = j; return j; })
      .catch(function () { return null; });   /* le repli Liquid reste affiché */
    return chargement;
  }

  function eur(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function peindreTarif(panneau) {
    var cible = panneau.querySelector('[data-livr-tarif]');
    var liste = panneau.querySelector('[data-livr-liste]');
    if (!cible) return;
    chargerTarifs().then(function (j) {
      if (!j || !j.pays) return;                       /* on garde le repli */
      var code = (window.Shopify && window.Shopify.country) || 'FR';
      var mien = j.pays[code];
      if (mien) {
        cible.textContent = mien.c === 0
          ? (panneau.dataset.tOfferte || 'Livraison offerte chez toi.')
          : (panneau.dataset.tPayante || 'Livraison @@ chez toi.').replace('@@', eur(mien.c));
      }
      if (liste && !liste.childElementCount) {
        var codes = Object.keys(j.pays).sort(function (a, b) {
          return j.pays[a].c - j.pays[b].c || j.pays[a].n.localeCompare(j.pays[b].n, 'fr');
        });
        codes.forEach(function (c) {
          var li = document.createElement('li');
          var n = document.createElement('span'); n.textContent = j.pays[c].n;
          var v = document.createElement('b');
          v.textContent = j.pays[c].c === 0 ? 'offerte' : eur(j.pays[c].c);
          li.appendChild(n); li.appendChild(v); liste.appendChild(li);
        });
      }
    });
  }

  /* ⛔ `overflow: hidden` SUR LE BODY NE BLOQUE RIEN ICI — 30/08, 06h05.
       Sa demande : « bloque le scroll quand c'est affiché ».
       J'avais mis `document.body.style.overflow = 'hidden'` en croyant que
       c'était fait. MESURÉ, pop-up ouverte : je fais défiler de 400 px, la page
       défile de 400 px. Le blocage n'a jamais fonctionné.
       LA RAISON : `<html>` porte `overflow: clip visible`, et sur mobile c'est
       LUI qui défile, pas `<body>`. Verrouiller le body seul ne verrouille rien —
       et ça ne lève aucune erreur, donc ça passe pour fait.

     ➜ LA SEULE MÉTHODE QUI TIENT SUR IOS : on fige le body en `position: fixed`
       avec un `top` négatif égal au défilement courant. La page ne peut plus
       bouger, et l'écran ne saute pas puisqu'on la décale d'exactement ce qu'elle
       avait défilé. À la libération, on restaure la position au pixel.

     ⚠️ UN COMPTEUR, PAS UN BOOLÉEN. Le tiroir de panier verrouille aussi. Si la
       pop-up se ferme alors que le tiroir est encore ouvert, un simple
       « je libère » rendrait le défilement sous un tiroir ouvert. Et l'inverse —
       chacun libérant l'autre — laisserait la page figée pour le reste de la
       visite : c'est exactement ce qui lui est arrivé le 24/08 avec la barre
       d'achat restée invisible. Le verrou compte ses porteurs. */
  function verrou() {
    if (!window.__onixVerrouScroll) {
      window.__onixVerrouScroll = { n: 0, y: 0 };
    }
    return window.__onixVerrouScroll;
  }

  function bloquerScroll() {
    var v = verrou();
    if (v.n === 0) {
      v.y = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-v.y) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
    }
    v.n++;
  }

  function libererScroll() {
    var v = verrou();
    v.n = Math.max(0, v.n - 1);
    if (v.n > 0) return;                       /* une autre surface le tient */
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    /* 'instant' : un retour en douceur ferait glisser la page sous les yeux du
       client, ce qui se lit comme un bug et non comme une transition. */
    window.scrollTo({ top: v.y, behavior: 'instant' });
  }

  function ouvrir() {
    var p = document.querySelector('[data-livr-panneau]');
    if (!p || !p.hasAttribute('hidden')) return;   /* déjà ouvert : pas 2 verrous */
    p.removeAttribute('hidden');
    bloquerScroll();
    peindreTarif(p);
    var x = p.querySelector('[data-livr-fermer]');
    if (x && x.focus) x.focus();
  }

  function fermer() {
    var p = document.querySelector('[data-livr-panneau]');
    if (!p || p.hasAttribute('hidden')) return;    /* déjà fermé : pas 2 libérations */
    p.setAttribute('hidden', '');
    libererScroll();
  }

  /* ⛔ UNE SEULE FOIS, MÊME SI LE FICHIER EST CHARGÉ DEUX FOIS — 31/08.
       C'est exactement ce qui est arrivé : deux <script> pour ce fichier, donc
       deux écouteurs, donc un `toggleAttribute` annulé par l'autre. L'inclusion
       en double est retirée ; ce garde fait que le défaut ne peut pas revenir
       si quelqu'un la remet un jour. */
  if (window.__onixLivraisonBranche) return;
  window.__onixLivraisonBranche = true;

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-livr-ouvrir]')) { e.preventDefault(); ouvrir(); return; }
    if (e.target.closest('[data-livr-fermer]')) { e.preventDefault(); fermer(); return; }
    var t = e.target.closest('[data-livr-tous]');
    if (t) {
      e.preventDefault();
      var l = document.querySelector('[data-livr-liste]');
      if (l) l.toggleAttribute('hidden');
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermer();
  });
})();
